export default () => ({
  items: [],
  sum: 0,
  status: undefined,
});
